'use client'

import { cn } from '@/presentation/utils'
import * as ProgressPrimitive from '@radix-ui/react-progress'

export const Progress = ({
  className,
  indicatorClassName,
  value,
  ...props
}: ProgressPrimitive.ProgressProps & { indicatorClassName?: string }) => (
  <ProgressPrimitive.Root
    className={cn('relative h-2 w-full overflow-hidden rounded-full bg-primary/20', className)}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn('h-full w-full flex-1 bg-primary transition-all', indicatorClassName)}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
)
